<template>
    <div  class="star-box" :class="{'star-14':starsize==14,'star-18':starsize==18,'star-44':starsize==44,'star-24':starsize==24}">
        <template v-for="(item,index) in  5">
            <div v-if="(score - index) >= 1" data-status="on" class="star on"></div>
            <div v-else data-status="off" class="star off"></div>
        </template>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.star-box{
    display: inline-block;
    font-size:0;
    line-height:0;
    vertical-align: middle;
    &.star-14{
        .star{
            display: inline-block;
            width: 14px;
            height: 14px;
            margin-right: 2px;
            background-size: contain;
            background-repeat: no-repeat;
            &:last-child{
                margin-right: 0;
            }
            &.on{
                background-image: url('http://p1.fishqc.net/Ft6tMQ74tQ6suuaXqCaZ2KMkRckX');
            }
            &.off{
                background-image: url('http://p1.fishqc.net/FtXRAuQwExz7fMC7u9GxEaCWvH3V');
            }
        }
    }
    &.star-18{
        .star{
            display: inline-block;
            width: 18px;
            height: 18px;
            margin-right: 4px;
            background-size: contain;
            background-repeat: no-repeat;
            &:last-child{
                margin-right: 0;
            }
            &.on{
                background-image: url('http://p1.fishqc.net/Ft6tMQ74tQ6suuaXqCaZ2KMkRckX');
            }
            &.off{
                background-image: url('http://p1.fishqc.net/FtXRAuQwExz7fMC7u9GxEaCWvH3V');
            }
        }
    }
    &.star-44{
        .star{
            display: inline-block;
            width: 44px;
            height: 44px;
            margin-right: 10px;
            background-size: contain;
            background-repeat: no-repeat;
            &:last-child{
                margin-right: 0;
            }
            &.on{
                background-image: url('https://try.fishqc.com/img/xing-active.png');
            }
            &.off{
                background-image: url('https://try.fishqc.com/img/xing-default.png');
            }
        }
    }
    &.star-24{
        .star{
            display: inline-block;
            width: 24px;
            height: 24px;
            margin-right: 10px;
            background-size: contain;
            background-repeat: no-repeat;
            &:last-child{
                margin-right: 0;
            }
            &.on{
                background-image: url('https://try.fishqc.com/img/xing-active.png');
            }
            &.off{
                background-image: url('https://try.fishqc.com/img/xing-default.png');
            }
        }
    }
}
</style>

<script>
import { myMixin } from '@/mixin/mixin.js'

export default {
    name: 'star',
    props: {
        starsize: {
            type: [Number, String],
            default: 20
        },
        score:{
            type: [Number,String],
            default: 0
        }
        
    },
    components: {

    },
    mixins: [myMixin],
    data() {
        return {

        }
    },
    methods: {
        choosetab(item) {},
    },
    computed: {
       
    },
    mounted() {
        console.log()
    }
}
</script>